<template>
  <div id="tablePage">
    <!-- 历史成交查询 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        :cell-class-name="directionClass"
        @sort-change="sortChange"
        v-loading="loading"
      >
      <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column
          prop="tradeId"
          label="成交单号"
        >
        </el-table-column>
        <el-table-column
          prop="orderId"
          label="委托单号"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="成交时间"
          width="90"
        >

        </el-table-column>
        <!-- <el-table-column
          prop="commodityCode"
          label="商品代码"
        >
        </el-table-column> -->
        <el-table-column
          prop="commodityName"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          prop="bsFlag"
          label="买|卖"
          sortable="custom"
        >
          <!-- <template slot-scope="scope">
            <span :class="scope.row.typeTrade=='B'?'red-row':'green-row'"> {{ scope.row.typeTrade=='B'?'买入':'卖出' }}</span>
          </template>-->
        </el-table-column>
        <el-table-column
          prop="tradeType"
          label="订立|转让"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.tradeType | tradeTypeFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="tradePrice"
          label="订立价格"
        >
          <template slot-scope="scope">
            <span v-if="isHistory">{{ Number(scope.row.singlePrice).toFixed(scope.row.priceScale) }}</span>
            <span v-else>{{ Number(scope.row.tradePrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="成交数量"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="成交金额"
        >
          <template slot-scope="scope">
            <span v-if="isHistory"> {{ Number(scope.row.funds).toFixed(scope.row.priceScale) }}</span>
            <span v-else> {{ Number(scope.row.totalAmount).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="cjjg"
          label="转让价格"
        >
          <template slot-scope="scope">
            <span v-if="isHistory"> {{ scope.row.cjjg }}</span>
            <span v-else> {{ scope.row.ocFlag=='转让' ? scope.row.singlePrice : 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="closePl"
          label="转让盈亏"
        >
          <template slot-scope="scope">
            <span :class="scope.row.textColor" v-if="isHistory"> {{ scope.row.closePl }}</span>
            <span :class="scope.row.textColor" v-else> {{ util.floatAdd(scope.row.closePl, scope.row.holdClosePl) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="stampFee"
          label="印花税"
          min-width="80"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.stampFee }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="fee"
          label="交易手续费"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.fee }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="cjType"
          label="成交类型"
        >
          <template slot-scope="scope">
            <span> 正常交易</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="createTime"
          label="订立转让时间"
          min-width="165"
        >
        </el-table-column> -->
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http protocol util*/
import { mapGetters } from 'vuex'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['time', 'isSearch'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      checked: false,
      tableData: [],
      isHistory: false, // 是否为历史接口
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      // 表格label宽度
      tcdTableWidth: {
        bsFlag: 80,
        ocFlag: 110,
        closePl: 100
      },
      TradeListSum: {
        bsFlag: '',
        cjType: '',
        cjje: null,
        cjjg: null,
        closePl: null,
        commodityCode: '',
        commodityId: null,
        commodityName: '',
        createTime: null,
        fee: null,
        firmId: null,
        holdDetailId: null,
        margin: null,
        minPriceChange: null,
        ocFlag: '',
        orderId: null,
        priceScale: null,
        quantity: null,
        singlePrice: null,
        stampFee: null,
        stampFeeRate: null,
        tqTip: null,
        tradeDay: null,
        tradeId: null,
        tradeType: null,
        updateTime: null
      },
      isNetWrong: false,
      beginTime: [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))]
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'commodityStrategyGetter'])
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      let currentProtocol = protocol.queryUserClinchesNew
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        currentProtocol = protocol.queryUserClinchHSNew
        currentProtocol.data.startTradeDay = this.time[0]
        currentProtocol.data.endTradeDay = this.time[1]
        currentProtocol.data.page = this.pageData.currentPage
      } else {
        currentProtocol.data.page = this.pageData.currentPage - 1
      }
      currentProtocol.data.size = '' + this.pageData.pageSize
      currentProtocol.data.bsFlag = null
      currentProtocol.data.commodityId = null
      // currentProtocol.data.tradeType = null
      currentProtocol.data.tradeType = [1, 2, 4, 15]
      http.gPostHs(currentProtocol).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.isHistory = true
            } else {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.isHistory = false
            }
            // this.TradeListSum = response.data.value.sumData
          }
          // this.querySum()
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })

      // protocol.queryTradeListSum.data = protocol.queryUserClinchesNew.data
      // http.gPost(protocol.queryTradeListSum).then(response => {
      //   if (response.data.code != 0) {
      //     this.$message({ message: response.data.message })
      //   }
      //   if (response.data) {
      //     if (response.data && response.data.code == '0') {
      //       this.TradeListSum = response.data.value
      //     }
      //   }
      // })
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 3) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 7) { // 成交数量
          sums[index] = that.TradeListSum.quantity
          return
        }
        if (index === 8) { // 成交金额
          sums[index] = that.TradeListSum.funds.toFixed(2)
          return
        }
        // if (index === 10) { // 转让价格
        //   sums[index] = that.TradeListSum.fee
        //   return
        // }
        if (index === 10) { // 利润
          sums[index] = this.util.floatAdd(that.TradeListSum.closePl, that.TradeListSum.holdClosePl)
          return
        }
        if (index === 11) { // 印花税
          sums[index] = that.TradeListSum.stampFee.toFixed(2)
          return
        }
        if (index === 12) { // 手续费
          sums[index] = that.TradeListSum.fee.toFixed(2)
          return
        }
        sums[index] = ''
      })
      return sums
    },
    querySum() {
      if (this.time) {
        // 历史
        protocol.queryTradeFrontHSum.data.startTradeDay = this.time[0]
        protocol.queryTradeFrontHSum.data.endTradeDay = this.time[1]
      } else {
        protocol.queryTradeFrontHSum.data.startTradeDay = null
        protocol.queryTradeFrontHSum.data.endTradeDay = null
      }
      protocol.queryTradeFrontHSum.data.bsFlag = null
      protocol.queryTradeFrontHSum.data.commodityId = null
      protocol.queryTradeFrontHSum.data.tradeType = [1, 2, 4, 8, 15]
      http.gPostHs(protocol.queryTradeFrontHSum).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.TradeListSum = response.data.value
          } else {
            this.$message(response.data.message)
          }
        }
      })
    },
    threeTxtColor(price) {
      // 商品价格大于0红色，小于0绿色，等于0灰色
      if (!isNaN(price)) {
        if (price > 0) {
          return 'red-row'
        } else if (price < 0) {
          return 'green-row'
        } else {
          return ''
        }
      }
      return ''
    },
    // 判断数据类型
    judgeDataType(arr) {
      console.log(arr, 123)
      const that = this
      this.each(arr, function(arrIndex) {
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        stateList.forEach((item, index) => {
          that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        })
        arrIndex.textColor = that.threeTxtColor(Number(arrIndex.closePl))
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      let currentProtocol = protocol.queryUserClinchesNew
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        currentProtocol = protocol.queryUserClinchHSNew
      }
      if (column.order == 'ascending') {
        currentProtocol.data.sort = [{
          'direction': 'ASC',
          'property': ''
        }]
        this.eachSortChange(column.column.property)
      } else if (column.order == 'descending') {
        currentProtocol.data.sort = [{
          'direction': 'DESC',
          'property': ''
        }]
        this.eachSortChange(column.column.property)
      } else {
        currentProtocol.data.sort = [{
          direction: 'DESC',
          property: 'tradeId'
        }]
      }
      if (column.column) {
        http.gPostHs(currentProtocol).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
                this.pageData.total = response.data.value.totalElements
                const arr = response.data.value.content
                this.judgeDataType(arr)
                this.isHistory = true
              } else {
                this.pageData.total = response.data.value.totalElements
                const arr = response.data.value.content
                this.judgeDataType(arr)
                this.isHistory = false
              }
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      let currentProtocol = protocol.queryUserClinchesNew
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        currentProtocol = protocol.queryUserClinchHSNew
      }
      return (currentProtocol.data.sort[0].property = str)
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      switch (row.columnIndex) {
        // eslint-disable-next-line no-lone-blocks
        case 4: {
          return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
        }
        case 5: {
          return this.setStrClass(row.row.ocFlag, '转让', 'dropColor', 'increaseColor')
        }
        default:
          break
      }
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>
